import { getAuth0AccessToken } from '../../auth/auth0Client';
import { API_BASE_URL } from '../config';
import { AppError, parseErrorResponse } from '../errors';

export interface GoogleOAuthExchangeParams {
  code: string;
  redirect_uri: string;
}

export interface GoogleOAuthExchangeResponse {
  access_token: string;
  token_type?: string;
  scope?: string;
  expires_in?: number;
  refresh_token?: string;
}

export async function googleOAuthExchange(
  params: GoogleOAuthExchangeParams
): Promise<GoogleOAuthExchangeResponse> {
  const auth0Token = await getAuth0AccessToken();
  if (!auth0Token) {
    throw new Error('Auth0 authentication required');
  }

  const response = await fetch(`${API_BASE_URL}/rpc/google_drive_oauth_exchange`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth0Token}`,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    if (errorPayload) {
      throw new AppError(errorPayload, response.status);
    }
    throw new Error(`Google OAuth exchange failed with status ${response.status}`);
  }

  return response.json() as Promise<GoogleOAuthExchangeResponse>;
}
